import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'filters',
    path: 'assignees',
    viewPath: props.viewPath,
  })

  let person = useDataValue({
    context: 'person',
    viewPath: props.viewPath,
  })

  let assignees = useDataValue({
    context: 'filters',
    path: 'assignees',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let shouldRemove = assignees.some(({ id }) => id === person.id)
    change([
      ...assignees.filter(({ id }) => id !== person.id),
      ...(shouldRemove ? [] : [person]),
    ])
  }
}

export function isChecked(assignees, assigneeId) {
  return assignees.some(({ id }) => id === assigneeId)
}
